import { Space } from "antd";
import React from "react";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import {
  EditOutlined,
  EyeOutlined,
  FileProtectOutlined,
} from "@ant-design/icons";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import tmsRouteMap from "../../../constants/tms-route.map";
import TmsShivaDeekshaService from "../../../services/shiva-deeksha.service";

const ShivaDeekshaInnerActions = ({
  record,
  setLoading,
  setViewShivaDeekshaData,
  settmsModalVisible,
  // eslint-disable-next-line no-unused-vars
  setUpdateFlag,
  setEditFlag,
  setProductId,
  router,
  setShowDrawer,
  setTermsData,
  setOnlineTermsData,
  setMiniTicket,
}) => {
  return (
    <Space size="middle">
      <a
        onClick={() => {
          router.navigate(
            `${tmsRouteMap.sm_shiva_deeksha_manage_counter}?id=${record.key}&name=${record?.name}`
          );
        }}
      >
        Manage POS
      </a>
      <a
        onClick={async () => {
          setLoading(true);
          try {
            const data = await TmsShivaDeekshaService.viewShivaDeeksha(
              record?.key
            );
            // console.log(darData);
            setViewShivaDeekshaData(data);
            settmsModalVisible(true);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
      >
        <EyeOutlined />
      </a>
      {/* <Popconfirm
        title="Are you sure delete this tollgate?"
        onConfirm={async () => {
          setLoading(true);
          try {
            await TmsTollGateService.deleteTollGate(record?.key);
            notification.success({
              message: "Thulabharam Deleted Successful",
            });
            setUpdateFlag(Math.Random + 1);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
        okText="Yes"
        cancelText="No"
      >
        <a>
          <DeleteOutlined />
        </a>
      </Popconfirm> */}
      <a
        onClick={async () => {
          setLoading(true);
          try {
            const darData = await TmsShivaDeekshaService.viewShivaDeeksha(
              record?.key
            );
            setViewShivaDeekshaData(darData);
            settmsModalVisible(true);
            setEditFlag(true);
            setProductId(record?.key);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
      >
        <EditOutlined />
      </a>
      <a
        onClick={() => {
          setShowDrawer(true);
          setProductId(record?.key);
          setTermsData(record?.metadata?.termsAndConditions);
          setOnlineTermsData(record?.metadata?.onlineTermsAndConditions);
          setMiniTicket(
            record.metadata?.ticketType === "mini_ticket" ? true : false
          );
        }}
      >
        <FileProtectOutlined />
      </a>
    </Space>
  );
};
export default withRouter(ShivaDeekshaInnerActions);
